import { produce } from 'immer';
import { AnimationClip } from 'three';
import { SetState, create } from 'zustand';
import { ChatAvatarData } from '~/types';

export type AssetStoreData = {
  animations: ChatAvatarData['animations'];
  currentAnimation: ChatAvatarData['currentAnimation'];
  animationState: ChatAvatarData['animationState'];
  selectedMotion: string;
};

export type AssetStoreStateActions = {
  setAnimations: (animations: AnimationClip[]) => void;
  setCurrentAnimation: (animation: AnimationClip) => void;
  setAnimationState: (state: ChatAvatarData['animationState']) => void;
  resetAvatarState: () => void;
  setSelectedMotion: (motionId: string) => void;
};

export type AssetStoreState = AssetStoreData & AssetStoreStateActions;

const initialAssetStoreState = (): AssetStoreData => ({
  animations: [],
  currentAnimation: undefined,
  animationState: {
    type: 'Idle',
  },
  selectedMotion: '',
});

const chatAvatarSetActions = (
  set: SetState<AssetStoreState>,
  get: () => AssetStoreState,
): AssetStoreStateActions => ({
  setAnimations: (animations) =>
    set(
      produce((state: AssetStoreState) => {
        state.animations = animations;
      }),
    ),

  setCurrentAnimation: (animation) =>
    set(
      produce((state: AssetStoreState) => {
        state.currentAnimation = animation;
      }),
    ),

  setAnimationState: (state) =>
    set(
      produce((s: AssetStoreState) => {
        s.animationState = state;
      }),
    ),
  setSelectedMotion: (id) =>
    set(
      produce((s: AssetStoreState) => {
        s.selectedMotion = id;
      }),
    ),

  resetAvatarState: () => set({ ...initialAssetStoreState() }),
});

const useAssetStoreState = create<AssetStoreState>()((set, get) => ({
  ...initialAssetStoreState(),
  ...chatAvatarSetActions(set, get),
}));

export default useAssetStoreState;
